import React, { useState, useRef, useEffect } from "react";
import LoadingBar from "react-top-loading-bar";
import TopBar from "../../sections/TopBar";
import Sidebar from "../../sections/Sidebar";
import "../../customCss/ManageOfficers.css";
import DataService from "../../services/data.service";
import { toast } from "react-toastify";
import { Modal } from "react-bootstrap";
import NotFound from "../../images/no-data-found.jpeg";
import Spinner from "../../sections/Spinner";
import {
  TextField,
  Autocomplete,
  FormControlLabel,
  Checkbox,
  Button,
  Typography,
  Stack,
  Card,
  CardContent,
} from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DatePicker } from "@mui/x-date-pickers/DatePicker";
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
import moment from "moment";
import dayjs from "dayjs";

const ManageProfile = () => {
  const ref = useRef();
  const navigate = useNavigate();
  const userData = JSON.parse(localStorage.getItem("tUser"));
  const userId = JSON.parse(localStorage.getItem("tUserId"));
  const [btnLoading, setBtnLoading] = useState(false);
  const [isSidebarOpen, setIsSidebarOpen] = useState(true);
  const [documentDetails, setDocumentDetails] = useState([]);
  useEffect(() => {
    document.title = "Manage Profile || Officer Apps";
    window.scrollTo(0, 0);
    //   getAllServices();
  }, []);
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("resize", handleResize);
    handleResize();

    return () => window.removeEventListener("resize", handleResize);
  }, []);
  const toggleSidebar = () => {
    setIsSidebarOpen((prev) => !prev);
  };
  useEffect(() => {
    if (userId) {
      getAdminData(userId);
    }
  }, [userId]);

  const getAdminData = () => {
    DataService.getOfficersById(userId)
      .then((data) => {
        ref.current.continuousStart();
        const officerData = data?.data?.data;
        setDocumentDetails(
          officerData?.documentDetails?.length > 0
            ? officerData?.documentDetails?.map((doc) => ({
                id: uuidv4(),
                documentName: doc?.documentName || "",
                documentNumber: doc?.documentNumber || "",
                documentFile: null,
                documentUrl: doc?.documentFile?.path || "",
                startDate: doc?.startDate ? dayjs(doc?.startDate) : null,
                expiryDate: doc?.expiryDate ? dayjs(doc?.expiryDate) : null,
              }))
            : []
        );

        ref.current.complete();
      })
      .catch((error) => {
        console.error("Error fetching sites details:", error);
        ref.current.complete();
      });
  };
  const removeDocument = (idToRemove) => {
    setDocumentDetails((prev) => prev.filter((doc) => doc?.id !== idToRemove));
  };

  const handleInputChange = (id, key, value) => {
    setDocumentDetails((prev) =>
      prev.map((doc) => (doc?.id === id ? { ...doc, [key]: value } : doc))
    );
  };

  const handleFileChange = (e, id) => {
    const file = e.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.onloadend = (event) => {
      setDocumentDetails((prev) =>
        prev.map((doc) =>
          doc?.id === id
            ? { ...doc, documentFile: file, documentUrl: event.target.result }
            : doc
        )
      );
    };

    reader.readAsDataURL(file);
  };
  const addNewDocument = () => {
    setDocumentDetails((prev) => [
      ...prev,
      {
        id: uuidv4(),
        documentName: "",
        documentNumber: "",
        documentFile: "",
        documentUrl: "",
        startDate: "",
        expiryDate: "",
      },
    ]);
  };
  const handleSubmit = (e) => {
    e.preventDefault();
    setBtnLoading(true);
    // const isFormValid = documentDetails.every(
    //   (doc) =>
    //     doc?.documentName.trim() &&
    //     doc?.documentNumber.trim() &&
    //     (doc?.documentFile || doc?.documentUrl) &&
    //     doc?.startDate &&
    //     doc?.expiryDate
    // );

    // if (!isFormValid) {
    //   toast.error("Please fill out all fields for each document.");
    //   setBtnLoading(false);
    //   return;
    // }

    const formData = new FormData();
    const docsValid = documentDetails.every(
      (d) => d.documentName?.trim() && d.documentNumber?.trim()
    );

    if (!docsValid) {
      toast.error(
        "Please provide both Document Name and Document Number for every document."
      );
      setBtnLoading(false);
      return;
    }
    documentDetails.forEach((doc, index) => {
      formData.append(`documentName[${index}]`, doc?.documentName);
      formData.append(`documentNumber[${index}]`, doc?.documentNumber);
      formData.append(`startDate[${index}]`, doc?.startDate ? doc?.startDate?.toISOString() : "");
      formData.append(`expiryDate[${index}]`, doc?.expiryDate ? doc?.expiryDate?.toISOString() : "");

      if (doc?.documentFile) {
        formData.append(`documentFile[${index}]`, doc?.documentFile);
      }
    });
    if (documentDetails?.length > 0) {
      formData.append("keepExistingDocuments", true);
    } else {
      formData.append("keepExistingDocuments", false);
    }

    DataService.updateOfficerById(userId, formData)
      .then(() => {
        getAdminData();
        toast.success("Documents Updated Successfully!");
        setBtnLoading(false);
      })
      .catch((error) => {
        const resMessage = error?.response?.data?.message;
        setBtnLoading(false);
        toast.error(resMessage);
      });
  };
  return (
    <>
      <LoadingBar color="#084e8a" ref={ref} height={5} />
      <div
        className={`main_layout ${
          isSidebarOpen ? "sidebar-open" : "sidebar-closed"
        }`}
      >
        <Sidebar isSidebarOpen={isSidebarOpen} />
        <div className="innerRight">
          <TopBar
            title="Manage Profile"
            menu=""
            toggleSidebar={toggleSidebar}
          />
          <div className="addOfficerSec px-3">
            <div className="row mb-3 mt-2">
              <div className="col-sm-6">
                <p className="mb-0 fs-6">
                  <span
                    className="fs-6 d-inline-block me-2 text-dark"
                    style={{ width: "140px" }}
                  >
                    Company Name
                  </span>
                  <span
                    className="fs-6 d-inline-block me-2 text-dark"
                    style={{ width: "20px" }}
                  >
                    :
                  </span>{" "}
                  {userData?.companyName}
                </p>
                <p className="mb-0 fs-6">
                  <span
                    className="fs-6 d-inline-block me-2 text-dark"
                    style={{ width: "140px" }}
                  >
                    Email
                  </span>
                  <span
                    className="fs-6 d-inline-block me-2 text-dark"
                    style={{ width: "20px" }}
                  >
                    :
                  </span>{" "}
                  {userData?.emailAddress}
                </p>
                <p className="mb-0 fs-6">
                  <span
                    className="fs-6 d-inline-block me-2 text-dark"
                    style={{ width: "140px" }}
                  >
                    Phone
                  </span>
                  <span
                    className="fs-6 d-inline-block me-2 text-dark"
                    style={{ width: "20px" }}
                  >
                    :
                  </span>{" "}
                  {userData?.phoneNumber}
                </p>
              </div>
            </div>
            <hr />
            <h5>Manage Documents</h5>
            <div className="row align-items-stretch g-4 mb-3">
              {documentDetails.map((doc, index) => (
                <div className="col-sm-4" key={doc?.id}>
                  <Card
                    variant="outlined"
                    className="docInner"
                    style={{ padding: 8 }}
                  >
                    <i
                      className="fas fa-times"
                      onClick={() => removeDocument(doc?.id)}
                    />
                    <CardContent>
                      <Typography
                        variant="h6"
                        gutterBottom
                        sx={{ textAlign: "left", marginBottom: "20px" }}
                      >
                        Document {index + 1}
                      </Typography>
                      <div className="row">
                        <div className="col-sm-6">
                          <TextField
                            label="Document Name"
                            fullWidth
                            size="small"
                            value={doc?.documentName || ""}
                            onChange={(e) =>
                              handleInputChange(
                                doc?.id,
                                "documentName",
                                e.target.value
                              )
                            }
                            sx={{ mb: 2 }}
                          />
                        </div>
                        <div className="col-sm-6">
                          <TextField
                            label="Document Number"
                            fullWidth
                            size="small"
                            value={doc?.documentNumber || ""}
                            onChange={(e) =>
                              handleInputChange(
                                doc?.id,
                                "documentNumber",
                                e.target.value
                              )
                            }
                            sx={{ mb: 2 }}
                          />
                        </div>
                      </div>
                      <LocalizationProvider dateAdapter={AdapterDayjs}>
                        <div className="row mb-3">
                          <div className="col-sm-6">
                            <DatePicker
                              label="Start Date"
                              value={doc?.startDate || null}
                              onChange={(date) =>
                                handleInputChange(doc?.id, "startDate", date)
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: "small",
                                },
                              }}
                            />
                          </div>
                          <div className="col-sm-6">
                            <DatePicker
                              label="Expiry Date"
                              value={doc?.expiryDate || null}
                              disablePast
                              onChange={(date) =>
                                handleInputChange(doc?.id, "expiryDate", date)
                              }
                              slotProps={{
                                textField: {
                                  fullWidth: true,
                                  size: "small",
                                },
                              }}
                            />
                          </div>
                        </div>
                      </LocalizationProvider>
                      <input
                        type="file"
                        accept=".pdf,.doc,.docx,image/*"
                        style={{ display: "none" }}
                        id={`file-input-${doc?.id}`}
                        onChange={(e) => handleFileChange(e, doc?.id)}
                      />
                      {doc?.documentFile ? (
                        <div
                          style={{
                            fontSize: 40,
                            textAlign: "center",
                            color: "#dc3545",
                            marginBottom: 10,
                          }}
                        >
                          <i className="far fa-file-pdf"></i>
                          <div style={{ fontSize: 14, color: "#333" }}>
                            {doc?.documentFile.name}
                          </div>
                        </div>
                      ) : doc?.documentUrl ? (
                        <div style={{ textAlign: "center", marginBottom: 10 }}>
                          <a
                            href={doc?.documentUrl}
                            target="_blank"
                            rel="noreferrer"
                            className="text-decoration-none"
                            style={{ color: "#1976d2" }}
                          >
                            <i
                              className="far fa-file-pdf"
                              style={{ marginRight: 8 }}
                            ></i>
                            View Existing File
                          </a>
                        </div>
                      ) : null}

                      <label
                        className="d-block"
                        htmlFor={`file-input-${doc?.id}`}
                      >
                        <Button
                          variant="contained"
                          component="span"
                          fullWidth
                          sx={{ width: "100%" }}
                        >
                          Upload File
                        </Button>
                      </label>
                    </CardContent>
                  </Card>
                </div>
              ))}
              <div className="col-sm-4">
                <div className="addMoreSec" onClick={addNewDocument}>
                  <i className="fas fa-plus" />
                  <p>Add Document</p>
                </div>
              </div>
            </div>
            <div className="row mb-2">
              <div className="col-sm-12 d-flex justify-content-end align-items-center">
                <button
                  className="btn btn-primary"
                  disabled={btnLoading}
                  onClick={handleSubmit}
                >
                  {btnLoading ? <Spinner /> : "Update Documents"}
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default ManageProfile;
